import React, {useState, useEffect} from 'react';
import { Drawer, Button, TextField, Typography, makeStyles, Select, InputLabel, Grid, CircularProgress, Card } from '@material-ui/core';
import UserManagementPageApis from "../services/UserManagementPageServices";
import ExpandMoreStyledIcon from "../../../common-components/expandMoreStyledIcon/expandMoreStyledIcon";
import HeaderApi from "../../../common-components/header/services/header-apis";
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: window.innerWidth/2.8,
    padding: theme.spacing(5),
  },
  formField: {
    marginBottom: theme.spacing(2),
    backgroundColor: 'white', // Same background color as in LogIn component
    width: 300
  },
  drawerHeader: {
    marginBottom: theme.spacing(1),
  },
  partDetails: {
  color: '#194cab',
  opacity: 1,
  fontFamily: 'Barlow',
  fontSize: 22,
  },
  partSubDetails: {
    color: '#b9b8b8',
    opacity: 1,
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: 0.14,
    fontStyle: 'italic',
  },
  proceed: {
    "&:hover": {
      opacity: 1,
    },
    background:
      "transparent linear-gradient(90deg, #0055A4 0%, #0079E6 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: 'Barlow',
    opacity: .8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
  cancelButton: {
    marginTop: theme.spacing(1),
    background: "transparent linear-gradient(90deg, #bebfc046 0%, #bebfc046 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: "Barlow",
    opacity: 0.8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
}));

const CreateEditGrandparentAccountDrawer = ({ open, onClose }) => {
  const userManagementPageApi = new UserManagementPageApis();
  const headerApi = new HeaderApi();
  const classes = useStyles();
  const [grandparentAccountInfo, setUserInfo] = useState({
    // grandParentAccountId: 0,
    grandParentAccountName: "",
    ownedBy: "",
    createdBy: "",
    createdDate: "",
    updatedBy: "",
    updatedDate: "",
    isActive: true,
  });
  const [loading, setLoading] = useState(false);
  const [isDisable, setDisable] = useState(true);
  const [accountInfo, setAccountInfo] = useState(JSON.parse(localStorage.getItem('accountInfo'))? JSON.parse(localStorage.getItem('accountInfo')) : {});
  const [grandparentAccountList, setGrandParentAccList] = useState([]);
  const [parentAccountList, setParentAccountList] = useState();
  const [toAssignAccount, setToAssignAccount] = useState({
    parentAccountId: 0, // in API it will be username
    grandParentAccountId: 0,
  });


   //Create Grand Parent Account Functions
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo({ ...grandparentAccountInfo, [name]: value });
  };


  const formCheck = () => {
    const hasLetters = (myString) => {
    let regExp = /[a-z]/i;
    let hasLetters = regExp.test(myString)
    return hasLetters;
    }
    if (grandparentAccountInfo.grandParentAccountName.length > 0) {
        setDisable(false);
    } else setDisable(true);
  }
  
  const save = () => {
    setLoading(true);
    let date = new Date();

    let grandparentAccountToSave = {
      // grandParentAccountId:grandparentAccountList.length + 1,
      grandParentAccountName: grandparentAccountInfo.grandParentAccountName,
      ownedBy: grandparentAccountInfo.ownedBy,
      createdBy: accountInfo?.userProfile?.userId,
      createdDate: date,
      updatedBy: accountInfo?.userProfile?.userId,
      updatedDate: date,
      isActive: true,
    }

    userManagementPageApi.createGrandparentAccount(grandparentAccountToSave).then((response) => {
      if (response.status === 200 || response?.message?.includes("successfully")) {
        setLoading(false);
        alert("Grandparent Account created successfully");
        onClose();
        window.location.reload();
      } else {
        setLoading(false);
        alert(`Grandparent Account creation failed. ${response?.data?.message}. Please contact EmTrack Support`);
        onClose();
      }
    });
  }

  // Assign Grand Parent Account Functions
  const compareStrings = (a, b) => {
    // Assuming you want case-insensitive comparison
    a = a.trim();
    b = b.trim();
    a = a.toLowerCase();
    b = b.toLowerCase();
    if (a < b) {
      return -1;
    } else {
      return a > b ? 1 : 0;
    }
  };

  const setParentAcctListFromResponseData = (responseData) => {
    let parentAccountListObject = [];
    const model = responseData.model;
    model.sort(function (a, b) {
      return compareStrings(a.accountName, b.accountName);
    });
    for (const item of model) {
      parentAccountListObject.push({
        accountName: item.accountName,
        createdBy: item.createdBy,
        parentAccountId: item.parentAccountId,
      });
    }
    setParentAccountList(parentAccountListObject);
  }

  let parentAccList =
  parentAccountList?.length > 0 &&
  parentAccountList.map((user, i) => {
    return (<>
      {/* <option key={0} value={0}>Select Parent Account</option> */}
      <option key={user.parentAccountId} value={user.parentAccountId}>
        {user.parentAccountId}: {user.accountName} 
      </option>
    </>
    );
  }, this);

  let grandparentList =
  grandparentAccountList.length > 0 &&
  grandparentAccountList.map((user, i) => {
    return (<>
      {/* <option key={0} value={0}>Select Grandparent Account</option> */}
      <option key={user.grandParentAccountId} value={user.grandParentAccountId}>
        {user.grandParentAccountId}: {user.grandParentAccountName} 
      </option>
    </>
    );
  }, this);

  useEffect(() => {
    userManagementPageApi.getGrandparentAccountList().then((response) => {
      if (response?.model?.length > 0)
        setGrandParentAccList(response?.model)
    })  

    headerApi.getParentAccountList().then((response) => {
      setParentAcctListFromResponseData(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect (() => {
    formCheck();

  }, [grandparentAccountInfo])

  



  



  const handleAssignAccountChange = (e) => {
    const { name, value } = e.target;
    setToAssignAccount( {...toAssignAccount, [name]: parseInt(value, 10) } );
  };

  const AssignAccount = () => {
    setLoading(true);
    let assignInfo = {
      username: toAssignAccount.parentAccountId,
      grandParentAccountId: toAssignAccount.grandParentAccountId,
      parentAccountId: toAssignAccount.parentAccountId,
    }
    userManagementPageApi.updateGrandparentAccountParentAccount(assignInfo).then((response) => {
      if (response.status === 200 || response.message.includes("successfully")) {
        setLoading(false);
        alert("Grandparent Account assigned successfully");
        onClose();
        window.location.reload();
      } else {
        setLoading(false);
        alert(`Grandparent Account assignment failed. ${response?.data?.message}. Please contact EmTrack Support`);
        onClose();
      }
    });

  }

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Grid container>
        <Grid item sm={12}>
          <Typography variant="h5" className={classes.partDetails}>
            GRANDPARENT ACCOUNT INFORMATION
          </Typography>
        </Grid>
        <Grid item sm={12}>
        <span style={{fontStyle:'italic', color:'grayText'}} className={classes.partSubDetails}>Grandparent Account act as the main account of multiple list of parent account.</span>
        </Grid>
        <Grid item sm={12}>
          <Card style={{padding: 10, marginTop:30}}>
          <Grid item sm={12}>
            <Typography variant="h8" className={classes.partDetails} style={{marginTop:15}}>Create Grandparent Account</Typography>
          </Grid>
            <Grid item sm={12} style={{marginTop:15}}>
              <TextField
              margin="dense"
              name="ownedBy"
              label="OWNED"
              type="text"
              value={grandparentAccountInfo.ownedBy}
              onChange={handleChange}
              className={classes.formField}
              variant="outlined"
              style={{marginRight:40}}
            />
            </Grid>
            <Grid item sm={12} style={{marginTop:15}}>
              <TextField
              margin="dense"
              name="grandParentAccountName"
              label="Grandparent Account Name"
              type="text"
              value={grandparentAccountInfo.grandParentAccountName}
              onChange={handleChange}
              className={classes.formField}
              variant="outlined"
              style={{marginRight:40}}
            />

            </Grid>
            <Grid  item sm={7}></Grid>
            <Grid  item sm={4}>
              {loading ? <CircularProgress size={30} color="inherit" /> :
                <>
                  <Button
                    onClick={save}
                    color="primary"
                    variant="contained"
                    disabled={isDisable}
                    className={isDisable? classes.cancelButton : classes.proceed}
                    style={{ marginTop: 20, marginRight: 20 }}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={onClose}
                    color="secondary"
                    variant="contained"
                    style={{ marginTop: 20 }}
                    className={classes.cancelButton}
                  >
                    Cancel
                  </Button>
                </>
              }

            </Grid>
          </Card>
        </Grid>

        <Grid item sm={12}>
          <Card style={{padding: 10, marginTop:30}}>
            <Grid item sm={12}>
              <Typography variant="h8" className={classes.partDetails} style={{marginTop:15}}>Assign Grandparent Account on Parent Account</Typography>
            </Grid>
            <Grid item sm={12} style={{marginTop:15}}>
              <Grid item sm={12} style={{marginTop:15, marginLeft: 10}}>
               
                <InputLabel id="user-measurement-system-label">Parent Account</InputLabel>
                <Select
                    native
                    label="parent Account"
                    className="sub-edit-textbox"
                    IconComponent={ExpandMoreStyledIcon}
                    value={toAssignAccount.parentAccountId === 0 ? "" : toAssignAccount.parentAccountId}
                    name="parentAccountId"
                    onChange={handleAssignAccountChange}
                  >
                    {parentAccList}
                  </Select>
                
              </Grid>
              <Grid item sm={12} style={{marginTop:15, marginLeft: 10}}>
               
                <InputLabel id="user-measurement-system-label">Grandparent Account</InputLabel>
                <Select
                    native
                    label="Grandparent Account"
                    className="sub-edit-textbox"
                    IconComponent={ExpandMoreStyledIcon}
                    value={toAssignAccount.grandParentAccountId === 0 ? "" : toAssignAccount.grandParentAccountId}
                    name="grandParentAccountId"
                    onChange={handleAssignAccountChange}
                  >
                    {grandparentList}
                  </Select>
                 
              </Grid>
              <Grid  item sm={4}>
              {loading ? <CircularProgress size={30} color="inherit" /> :
                <>
                  <Button
                    onClick={AssignAccount}
                    color="primary"
                    variant="contained"
                    className={(toAssignAccount.parentAccountId === 0 || toAssignAccount.grandParentAccountId === 0) ? classes.cancelButton : classes.proceed}
                    style={{ marginTop: 20, marginRight: 20 }}
                    disabled={toAssignAccount.parentAccountId === 0 || toAssignAccount.grandParentAccountId === 0}
                  >
                    Assign
                  </Button>
                  <Button
                    onClick={onClose}
                    color="secondary"
                    variant="contained"
                    style={{ marginTop: 20 }}
                    className={classes.cancelButton}
                  >
                    Cancel
                  </Button>
                </>
              }

            </Grid>
            </Grid>
          </Card>
        </Grid>
        
      </Grid>

    </Drawer>
  );
};

export default CreateEditGrandparentAccountDrawer;